/**
 * Products Showcase Carousel - Sleek Theme OS 2.0
 */
if (!customElements.get('products-showcase')) {
  customElements.define(
    'products-showcase',
    class ProductsShowcase extends HTMLElement {
      constructor() {
        super();
        this.currentIndex = 0;
        this.track = null;
        this.slides = [];
        this.prevBtn = null;
        this.nextBtn = null;
        this.startX = 0;
        this.currentX = 0;
        this.isDragging = false;
      }

      connectedCallback() {
        this.track = this.querySelector('[data-slider-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slider-slide]'));
        this.prevBtn = this.querySelector('[data-slider-prev]');
        this.nextBtn = this.querySelector('[data-slider-next]');

        if (!this.track || this.slides.length === 0) return;

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => this.slidePrev());
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => this.slideNext());
        }

        // Touch & Drag Support
        this.track.addEventListener('touchstart', (e) => this.handleTouchStart(e), { passive: true });
        this.track.addEventListener('touchmove', (e) => this.handleTouchMove(e), { passive: true });
        this.track.addEventListener('touchend', () => this.handleTouchEnd());

        this.updateButtons();
      }

      slidePrev() {
        if (this.currentIndex > 0) {
          this.currentIndex--;
        } else {
          this.currentIndex = this.slides.length - 1; // loop
        }
        this.updatePosition();
      }

      slideNext() {
        if (this.currentIndex < this.slides.length - 1) {
          this.currentIndex++;
        } else {
          this.currentIndex = 0; // loop
        }
        this.updatePosition();
      }

      updatePosition() {
        const slide = this.slides[this.currentIndex];
        if (!slide) return;

        const slideWidth = slide.offsetWidth;
        const gap = 24; // approximate gap
        const offset = this.currentIndex * (slideWidth + gap);

        this.track.style.transform = `translateX(-${offset}px)`;
        this.updateButtons();
      }

      updateButtons() {
        if (!this.dataset.loop) {
          if (this.prevBtn) {
            this.prevBtn.disabled = this.currentIndex === 0;
          }
          if (this.nextBtn) {
            this.nextBtn.disabled = this.currentIndex === this.slides.length - 1;
          }
        }
      }

      handleTouchStart(e) {
        this.startX = e.touches[0].clientX;
        this.isDragging = true;
      }

      handleTouchMove(e) {
        if (!this.isDragging) return;
        this.currentX = e.touches[0].clientX;
      }

      handleTouchEnd() {
        if (!this.isDragging) return;
        this.isDragging = false;
        const diff = this.startX - this.currentX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) {
            this.slideNext();
          } else {
            this.slidePrev();
          }
        }
      }
    }
  );
}
